import { money as moneyFormat } from 'utils/format/money';

function dateFormat(value) {
  const date = new Date(value);

  return date.toLocaleDateString('en-US');
}

const columns = [
  {
    name: 'Enterprise',
    selector: (row) => row.attributes.enterprise_name,
    sortable: true,
  },
  {
    name: 'Policy number',
    selector: (row) => row.attributes.policy_number,
    sortable: true,
  },
  {
    name: 'Plan',
    selector: (row) => row.attributes.plan_name,
    sortable: true,
  },
  {
    name: 'Renewal Date',
    selector: (row) => row.attributes.renewal_date,
    cell: (row) => dateFormat(row.attributes.renewal_date),
  },
  {
    name: 'Covered EEs',
    selector: (row) => row.attributes.covered,
    sortable: true,
  },
  {
    name: 'Premium',
    selector: (row) => moneyFormat(row.attributes.premium, row.attributes.currency.title),
    sortable: true,
  },
  {
    name: 'Billing',
    selector: (row) => row.attributes.billing,
    sortable: true,
  },
  {
    name: 'Commission %',
    selector: (row) => `${row.attributes.commission} %`,
    sortable: true,
  },
];

export default columns;
